import { endOfMonth, parse, startOfMonth, subMonths } from 'date-fns';

export const parseStartDate = (dateString: string | null): Date => {
	const defaultDate = startOfMonth(subMonths(new Date(), 1));

	if (!dateString) {
		return defaultDate;
	}

	try {
		return parse(`${dateString}-01`, 'yyyy-MM-dd', new Date());
	} catch (error) {
		return defaultDate;
	}
};

export const parseEndDate = (dateString: string | null): Date => {
	const defaultDate = endOfMonth(subMonths(new Date(), 1));

	if (!dateString) {
		return defaultDate;
	}

	try {
		return endOfMonth(parse(`${dateString}-01`, 'yyyy-MM-dd', new Date()));
	} catch (error) {
		return defaultDate;
	}
};

export const parseMonthDate = (dateString: string | null): Date => {
	const defaultDate = endOfMonth(subMonths(new Date(), 1));

	if (!dateString) {
		return defaultDate;
	}

	try {
		return endOfMonth(parse(`${dateString}-01`, 'yyyy-MM-dd', new Date()));
	} catch (error) {
		return defaultDate;
	}
};